import api, { API_BASE_URL } from './api';

/**
 * Fetch admin orders with pagination and optional status filter.
 */
export const fetchAdminOrders = async ({ page = 1, per_page = 10, status } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('per_page', per_page);
  if (status && status !== 'all') {
    params.append('status', status);
  }

  const endpoint = `/admin/orders?${params.toString()}`;
  const response = await api.get(endpoint);
  return response.data;
};

/**
 * Fetch a single admin order with full details.
 */
export const fetchAdminOrder = async (id) => {
  const response = await api.get(`/admin/orders/${id}`);
  return response.data;
};

/**
 * Update order status (admin).
 */
export const updateAdminOrderStatus = async (id, status) => {
  const response = await api.put(`/admin/orders/${id}/status`, { status });
  return response.data;
};

/**
 * Update order line prices (admin).
 * @param {number} id
 * @param {{ items: { id: number, price: number }[] }} data
 */
export const updateAdminOrder = async (id, data) => {
  const response = await api.put(`/admin/orders/${id}`, data);
  return response.data;
};

/**
 * Download order as PDF (admin). Triggers browser download.
 */
export const downloadOrderPdf = async (id) => {
  const token = localStorage.getItem('token');
  const url = `${API_BASE_URL}/admin/orders/${id}/download/pdf`;
  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/pdf',
    },
  });
  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/admin/login';
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to download PDF');
  }
  const blob = await res.blob();
  const disposition = res.headers.get('Content-Disposition');
  const filename = disposition?.match(/filename="?([^";\n]+)"?/)?.[1]?.trim() || `order-${id}.pdf`;
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

/**
 * Download order as Excel/CSV (admin). Triggers browser download.
 */
export const downloadOrderExcel = async (id) => {
  const token = localStorage.getItem('token');
  const url = `${API_BASE_URL}/admin/orders/${id}/download/excel`;
  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'text/csv, application/csv',
    },
  });
  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/admin/login';
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to download Excel');
  }
  const blob = await res.blob();
  const disposition = res.headers.get('Content-Disposition');
  const filename = disposition?.match(/filename="?([^";\n]+)"?/)?.[1]?.trim() || `order-${id}.csv`;
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

